import { useQuery } from '@apollo/client';
import { useSelector } from 'src/store/react';
import { selectResultsJobIds } from 'src/store/selectors';
import { SEARCH_SAVED_AND_APPLIED_JOBS } from 'src/modules/graphql/queries/savedJobs';
import { useToggleSavedJob } from './utils/useToggleSavedJob';

const noop = () => {};

interface Options {
  jobId: string;
  jobTracking?: string;
  solMetadataReference?: string;
  isJobDetailsView?: boolean;
}

export const useSaveJobSERP = ({
  jobId,
  jobTracking,
  solMetadataReference,
}: Options) => {
  const jobIds = useSelector(selectResultsJobIds);

  const searchSavedAndAppliedJob = useQuery(SEARCH_SAVED_AND_APPLIED_JOBS, {
    variables: { jobIds },
  });

  const { toggleSavedJob, isApplied, isSaved } = useToggleSavedJob({
    jobId,
    jobIds,
    view: 'serp',
    linkPosition: 'listing',
    solMetadataReference,
    jobTracking,
    savedJobsData: searchSavedAndAppliedJob?.data,
  });

  return {
    isApplied,
    isSaved,
    toggleSavedJob: isApplied ? noop : toggleSavedJob,
  };
};
